import React, {useEffect, useState} from 'react';
import {formatToPersianAddComma} from "../../../utils/CommaSeparator";
import HeaderPrintSellFactor from "./HeaderPrintSellFactor";
import PageRowsPrintSellFactor from "./PageRowsPrintSellFactor";
import FooterPrintSellFactor from "./FooterPrintSellFactor";
import "./style.scss"

function PrintTypeSellFactor({data}) {

  let style = `
    @page {
      size: A4;
      padding: 0.5cm !important; 
      margin: 0.5cm !important;
    }
  `;
  let ROW_IN_PAGE = 0;
  if (data.sellFactorPrintSize === "A4") {
    ROW_IN_PAGE = 23
    style = `
    @page {
      size: A4;
      padding: 0.5cm !important; 
      margin: 0.5cm !important;
    }
  `;
  } else {
    ROW_IN_PAGE =17
    style = `
    @page {
      size: A5;
      padding: 1cm !important; 
      margin: 1cm !important;
    }
  `;
  }






  let myColumns: [] = data && data.data[0] && data.data[0].column ? data.data[0].column : [];
  let myData: [] = data && data.data[0] && data.data[0].data ? data.data[0].data : [];
  let fieldColumns: string[] = [];

  myColumns.forEach((myColumn) => {
    fieldColumns.push(myColumn.field);
  });

  let currency: string, title: string, factorId: String, textUnderPrint: string, bedSum: number, besSum: number;

  const [allPageData, setAllPageData] = useState([])
  //ساختن صفحات
  useEffect(() => {
    const newMyData = myData.map((v, index) => {
      const row = {...v}
      return {...v, rowIndex: index + 1}
    })


    const allData = []
    for (let i = 0; i < newMyData.length; i = i + ROW_IN_PAGE) {
      const singlePage = []

      for (let j = 0; j < ROW_IN_PAGE; j++) {
        newMyData[i + j] && singlePage.push(newMyData[i + j])
      }
      allData.push(singlePage)
    }

    setAllPageData(allData)
  }, []);


  return (<div>
    <style>{style}</style>
    {allPageData?.map((rows, index) => {


      return (<div className={"sellFactorPrint"}>
        <HeaderPrintSellFactor title={title} data={data} totlaPage={allPageData.length} currentPage={index + 1}/>
        <PageRowsPrintSellFactor data={data} myColumns={myColumns} rows={rows}/>
        <FooterPrintSellFactor data={data}/>
        {index+1 !== allPageData.length && <div className={"goNextPage"}></div>}
      </div>)

    })}


  </div>);
}

export default PrintTypeSellFactor;


